export { Clipboard as default } from './Clipboard';
